/* ============================================================
   PAARSHV theme — interactions ("Modern Royal Indo-Western")
   All motion respects prefers-reduced-motion.
   ============================================================ */
(function () {
  'use strict';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var pvSyncCoupon = null; // set by initCoupon; lets renderCart refresh the coupon box
  var galleryGoToMedia = null; // set by initGallery; lets initProduct jump on colour change

  /* Prices rendered here must carry the same currency symbol Liquid uses, so take the
     prefix/suffix straight from the store's money format (e.g. "Rs. {{amount}}" or
     "₹{{amount}}") rather than hardcoding one. Digit grouping stays Indian (en-IN), which
     is what the ₹ figures on the rest of the page use. */
  var MONEY_FORMAT = (window.PAARSHV && window.PAARSHV.moneyFormat) || '₹{{amount}}';
  var moneyParts = (function () {
    var m = MONEY_FORMAT.match(/^([\s\S]*?)\{\{\s*[a-z_]+\s*\}\}([\s\S]*)$/);
    return m ? { prefix: m[1], suffix: m[2] } : { prefix: '₹', suffix: '' };
  })();
  function money(cents) {
    var n = (cents / 100).toLocaleString('en-IN', { maximumFractionDigits: 0 });
    return moneyParts.prefix + n + moneyParts.suffix;
  }

  /* ---------- Scroll reveal ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.pv-reveal');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Header: back + share ---------- */
  function initHeaderActions() {
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-pv-back]')) {
        if (document.referrer && document.referrer.indexOf(window.location.host) !== -1) { history.back(); }
        else { window.location.href = '/'; }
      }
      var shareBtn = e.target.closest('[data-pv-share]');
      if (shareBtn) {
        if (navigator.share) {
          navigator.share({ title: document.title, url: window.location.href }).catch(function () {});
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(window.location.href).catch(function () {});
        }
      }
    });
  }

  /* ---------- Drawers (cart sheet + size-guide modal) ---------- */
  function openDrawer(drawer) {
    /* Only one sheet at a time — opening the wishlist from inside the profile panel
       must not leave both stacked on top of each other. */
    document.querySelectorAll('.pv-drawer.is-open').forEach(function (d) {
      if (d !== drawer) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); }
    });
    var overlay = document.querySelector('[data-pv-overlay]');
    if (overlay) overlay.classList.add('is-open');
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (drawer.hasAttribute('data-pv-cart-drawer')) { fetchCart(); }
    if (drawer.hasAttribute('data-pv-wishlist-sheet')) {
      renderWishlistInto(drawer.querySelector('[data-pv-wishlist-list]'), drawer.querySelector('[data-pv-wishlist-sheet-empty]'), 'sheet');
    }
    var closeBtn = drawer.querySelector('[data-pv-close]');
    if (closeBtn) closeBtn.focus();
  }
  function closeDrawers() {
    document.querySelectorAll('.pv-drawer').forEach(function (d) {
      d.classList.remove('is-open');
      if (d.hasAttribute('aria-hidden')) d.setAttribute('aria-hidden', 'true');
    });
    var overlay = document.querySelector('[data-pv-overlay]');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  function initDrawers() {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-pv-open]');
      if (opener) {
        var sel = opener.getAttribute('data-pv-open');
        var drawer = document.querySelector(sel);
        if (drawer) { e.preventDefault(); openDrawer(drawer); }
        else {
          /* The tab bar must never be a dead button if a sheet failed to render. */
          var fallback = opener.getAttribute('data-pv-fallback-url');
          if (fallback) { e.preventDefault(); window.location.href = fallback; }
        }
      }
      if (e.target.closest('[data-pv-close]') || e.target.matches('[data-pv-overlay]')) { closeDrawers(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });
  }

  /* ---------- Wishlist (persisted locally by product handle) ---------- */
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem('pv_wishlist') || '[]'); } catch (e) { return []; }
  }
  function setWishlist(list) {
    try { localStorage.setItem('pv_wishlist', JSON.stringify(list)); } catch (e) {}
  }
  /* Badges in the header + tab bar, and the "N saved" line in the profile panel. */
  function updateWishlistUI() {
    var count = getWishlist().length;
    document.querySelectorAll('[data-pv-wishlist-badge]').forEach(function (b) {
      b.textContent = count;
      b.hidden = count === 0;
    });
    document.querySelectorAll('[data-pv-wishlist-count]').forEach(function (c) {
      c.textContent = count ? '(' + count + ')' : '';
    });
    document.querySelectorAll('[data-pv-wishlist-sub]').forEach(function (s) {
      if (!s.getAttribute('data-default')) s.setAttribute('data-default', s.textContent.trim());
      s.textContent = count ? count + ' saved' : s.getAttribute('data-default');
    });
  }

  function initWishlist() {
    var stored = getWishlist();
    document.querySelectorAll('[data-pv-wish][data-product-handle]').forEach(function (btn) {
      if (stored.indexOf(btn.getAttribute('data-product-handle')) !== -1) btn.classList.add('is-on');
    });
    updateWishlistUI();

    document.addEventListener('click', function (e) {
      var w = e.target.closest('[data-pv-wish]');
      if (!w) return;
      e.preventDefault();
      var handle = w.getAttribute('data-product-handle');
      if (!handle) return;
      var list = getWishlist();
      var idx = list.indexOf(handle);
      var on = idx === -1;
      if (on) list.push(handle); else list.splice(idx, 1);
      setWishlist(list);

      /* Every heart for this product, wherever it is on the page, follows the stored
         state — not this button's own class — so the two never drift apart. */
      document.querySelectorAll('[data-pv-wish][data-product-handle="' + handle + '"]').forEach(function (other) {
        other.classList.toggle('is-on', on);
      });
      updateWishlistUI();

      var sheet = document.querySelector('[data-pv-wishlist-sheet]');
      if (sheet && sheet.classList.contains('is-open')) renderWishlistInto(sheet.querySelector('[data-pv-wishlist-list]'), sheet.querySelector('[data-pv-wishlist-sheet-empty]'), 'sheet');
    });
  }

  /* Hydrates saved handles into real products via Shopify's product JSON endpoint.
     A handle that no longer resolves (product deleted or unpublished) is dropped from
     storage rather than left to render as a broken card forever. */
  function renderWishlistInto(listEl, emptyEl, mode) {
    if (!listEl) return;
    var handles = getWishlist();
    if (!handles.length) {
      listEl.innerHTML = '';
      if (emptyEl) emptyEl.hidden = false;
      return;
    }
    Promise.all(handles.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (results) {
      var alive = [];
      var products = [];
      results.forEach(function (p, i) {
        if (p && p.handle) { alive.push(handles[i]); products.push(p); }
      });
      if (alive.length !== handles.length) { setWishlist(alive); updateWishlistUI(); }

      if (!products.length) {
        listEl.innerHTML = '';
        if (emptyEl) emptyEl.hidden = false;
        return;
      }
      if (emptyEl) emptyEl.hidden = true;
      listEl.innerHTML = products.map(function (p) {
        return mode === 'sheet' ? wishRowHtml(p) : wishCardHtml(p);
      }).join('');
    }).catch(function () {});
  }

  function firstAvailableVariant(p) {
    var vs = p.variants || [];
    for (var i = 0; i < vs.length; i++) { if (vs[i].available) return vs[i]; }
    return null;
  }

  function wishRowHtml(p) {
    var img = p.featured_image || (p.images && p.images[0]) || '';
    var v = firstAvailableVariant(p);
    var single = (p.variants || []).length === 1;
    var action = !v
      ? '<span class="pv-wishrow__oos">Sold out</span>'
      : single
        ? '<button type="button" class="pv-wishrow__add pv-focusable" data-pv-quickadd data-variant-id="' + v.id + '">Add to Bag</button>'
        : '<a href="' + p.url + '" class="pv-wishrow__add pv-focusable">Choose size</a>';
    return '<div class="pv-wishrow" data-wish-handle="' + p.handle + '">' +
      '<a href="' + p.url + '" class="pv-wishrow__img">' + (img ? '<img src="' + img + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' : '') + '</a>' +
      '<div class="pv-wishrow__body">' +
        '<a href="' + p.url + '" class="pv-wishrow__name">' + escapeHtml(p.title) + '</a>' +
        '<span class="pv-wishrow__price pv-tnum">' + money(p.price) + '</span>' +
        action +
      '</div>' +
      '<button type="button" class="pv-wishrow__remove pv-focusable" data-pv-wish data-product-handle="' + p.handle + '" aria-label="Remove from wishlist">' + svgX() + '</button>' +
    '</div>';
  }

  function wishCardHtml(p) {
    var img = p.featured_image || (p.images && p.images[0]) || '';
    return '<article class="pv-card">' +
      '<a href="' + p.url + '" class="pv-card__media pv-card__media--zoom">' + (img ? '<img class="pv-card__img" src="' + img + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' : '') + '</a>' +
      '<button class="pv-card__wish pv-focusable is-on" data-pv-wish data-product-handle="' + p.handle + '" aria-label="Remove from wishlist">' + svgHeart() + '</button>' +
      '<div class="pv-card__body">' +
        '<a href="' + p.url + '"><h3 class="pv-card__name">' + escapeHtml(p.title) + '</h3></a>' +
        '<div class="pv-card__price-row"><span class="pv-card__price">' + money(p.price) + '</span></div>' +
      '</div></article>';
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function svgX() { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.75" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>'; }

  /* ---------- AJAX cart ---------- */

  /* Rewards ladder — up to three spend milestones on one track. The tiers are rendered
     server-side by snippets/rewards-bar.liquid (from theme settings, so the merchant can
     change them per season); this only measures the live cart against them.
     Note: cart.total_price is the amount AFTER any cart-level discount already applied, so
     a shopper who has just unlocked 10% off doesn't get bounced back below the milestone —
     items_subtotal_price is the pre-discount figure the thresholds are actually judged on
     by Shopify's automatic discounts. */
  function updateRewards(cart) {
    var bars = document.querySelectorAll('[data-pv-rewards]');
    if (!bars.length) return;
    var total = cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price;

    bars.forEach(function (el) {
      var max = parseInt(el.getAttribute('data-max-cents'), 10) || 0;
      if (max <= 0) { el.hidden = true; return; }

      var stops = [].slice.call(el.querySelectorAll('[data-pv-rewards-stop]')).map(function (s) {
        return { el: s, cents: parseInt(s.getAttribute('data-cents'), 10) || 0, label: s.getAttribute('data-full-label') || '' };
      }).sort(function (a, b) { return a.cents - b.cents; });
      if (!stops.length) { el.hidden = true; return; }

      var pct = Math.max(0, Math.min(100, Math.round(total / max * 100)));
      var fill = el.querySelector('[data-pv-rewards-fill]');
      var pctEl = el.querySelector('[data-pv-rewards-pct]');
      if (fill) fill.style.width = pct + '%';
      if (pctEl) pctEl.textContent = pct + '%';

      var next = null, lastUnlocked = null;
      stops.forEach(function (s) {
        var unlocked = total >= s.cents;
        s.el.classList.toggle('is-unlocked', unlocked);
        if (unlocked) lastUnlocked = s;
        else if (!next) next = s;
      });

      el.classList.toggle('is-complete', !next);
      var msg = el.querySelector('[data-pv-rewards-msg]');
      if (!msg) return;

      var tpl;
      if (!next) {
        tpl = el.getAttribute('data-msg-all') || 'All rewards unlocked';
      } else if (!lastUnlocked) {
        tpl = (total > 0 ? el.getAttribute('data-msg-next') : el.getAttribute('data-msg-start')) || 'Add __AMOUNT__ more for __REWARD__';
        tpl = tpl.replace('__AMOUNT__', '<strong>' + money(next.cents - total) + '</strong>').replace('__REWARD__', next.label);
      } else {
        tpl = el.getAttribute('data-msg-unlocked-next') || '__REWARD__ unlocked · next: __NEXT__';
        tpl = tpl.replace('__REWARD__', '<strong>' + lastUnlocked.label + '</strong>')
                 .replace('__NEXT__', next.label + ' (' + money(next.cents - total) + ' away)');
      }
      msg.innerHTML = tpl;
    });
  }

  /* Shopify shapes cart_level_discount_applications differently depending on the endpoint:
     GET /cart.js returns it flat ({title, total_allocated_amount, ...}), but the POST
     /cart/change.js and /cart/add.js responses — which is what every drawer qty +/-, add,
     and remove feeds straight into renderCart — nest it instead
     ({amount, discount_application: {title, total_allocated_amount, ...}}), same shape as
     a line_level_discount_allocations entry. Reading d.title/d.total_allocated_amount
     directly only works for the flat shape; on the nested one both are undefined, which is
     why the drawer summary could fall back to a generic "Discount" title and ₹0 right after
     a qty change even though the line price was already correctly discounted. Unwrap
     discount_application when present so both shapes resolve to the same fields. */
  function collectDiscounts(cart) {
    var byTitle = {};
    (cart.cart_level_discount_applications || []).forEach(function (d) {
      var da = d.discount_application || d;
      var title = da.title || 'Discount';
      var amount = da.total_allocated_amount != null ? da.total_allocated_amount : (d.amount || 0);
      byTitle[title] = (byTitle[title] || 0) + amount;
    });
    (cart.items || []).forEach(function (it) {
      (it.line_level_discount_allocations || []).forEach(function (a) {
        var title = (a.discount_application && a.discount_application.title) || 'Discount';
        byTitle[title] = (byTitle[title] || 0) + (a.amount || 0);
      });
    });
    return Object.keys(byTitle).map(function (title) { return { title: title, total_allocated_amount: byTitle[title] }; });
  }

  function escHtml(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function updatePromo(cart) {
    var wrap = document.querySelector('[data-pv-promo]');
    var rows = document.querySelector('[data-pv-summary-discount]');
    var apps = collectDiscounts(cart);
    if (!apps.length) {
      if (wrap) wrap.hidden = true;
      if (rows) { rows.hidden = true; rows.innerHTML = ''; }
      return;
    }
    var saved = apps.reduce(function (sum, d) { return sum + (d.total_allocated_amount || 0); }, 0);
    if (wrap) {
      wrap.hidden = false;
      var title = wrap.querySelector('[data-pv-promo-title]');
      var sub = wrap.querySelector('[data-pv-promo-sub]');
      if (title) title.textContent = apps.length > 1 ? apps.length + ' OFFERS APPLIED' : (apps[0].title || 'Discount').toUpperCase() + ' APPLIED';
      if (sub) sub.textContent = 'You saved ' + money(saved);
    }
    if (rows) {
      rows.hidden = false;
      rows.innerHTML = apps.map(function (d) {
        return '<div class="pv-summary__row pv-summary__row--discount"><span>' + escHtml(d.title || 'Discount') + '</span><span class="pv-tnum">-' + money(d.total_allocated_amount || 0) + '</span></div>';
      }).join('');
    }
  }

  var RESERVE_MS = 15 * 60 * 1000;
  function reserveStart() {
    var v = sessionStorage.getItem('pv_cart_reserve_start');
    if (!v) { v = Date.now(); sessionStorage.setItem('pv_cart_reserve_start', v); }
    return parseInt(v, 10);
  }
  var reserveTimer = null;
  function initReserveCountdown() {
    var el = document.querySelector('[data-pv-reserve-time]');
    if (!el) return;
    if (reserveTimer) clearInterval(reserveTimer);
    var start = reserveStart();
    function tick() {
      var remain = Math.max(0, RESERVE_MS - (Date.now() - start));
      var m = Math.floor(remain / 60000);
      var s = Math.floor((remain % 60000) / 1000);
      el.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s + ' mins';
    }
    tick();
    reserveTimer = setInterval(tick, 1000);
  }

  function renderCrossSell(productId) {
    var rail = document.querySelector('[data-pv-cart-upsell]');
    if (!rail || !productId) return;
    fetch('/recommendations/products.json?product_id=' + productId + '&limit=4&intent=complementary')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data && data.products) || [];
        if (!products.length) { rail.closest('[data-pv-cart-upsell-wrap]').hidden = true; return; }
        rail.closest('[data-pv-cart-upsell-wrap]').hidden = false;
        rail.innerHTML = products.map(function (p) {
          var img = p.featured_image || (p.images && p.images[0]) || '';
          return '<div class="pv-upsell__item">' +
            '<a href="' + p.url + '" class="pv-upsell__img">' + (img ? '<img src="' + img + '&width=160" alt="' + (p.title || '') + '">' : '') + '</a>' +
            '<div class="pv-upsell__body">' +
              '<a href="' + p.url + '" class="pv-upsell__name">' + p.title + '</a>' +
              '<span class="pv-upsell__price">' + money(p.price) + '</span>' +
              '<button type="button" class="pv-upsell__add" data-pv-quickadd data-variant-id="' + p.id + '"><span>+ Add</span></button>' +
            '</div></div>';
        }).join('');
      }).catch(function () {});
  }

  /* Shopify's cart endpoints return {status, message, description} (no .items) on
     failure (e.g. requesting more units than are in stock) — never feed that into
     renderCart, which assumes a real cart object. Refetch the true cart instead. */
  function handleCartResponse(data) {
    if (data && data.status && !data.items) {
      if (data.message) window.alert(data.message);
      fetchCart();
      return;
    }
    renderCart(data);
  }

  function renderCart(cart) {
    var badge = document.querySelector('[data-pv-cart-count]');
    if (badge) { badge.textContent = cart.item_count; badge.style.display = cart.item_count ? 'flex' : 'none'; }
    var itemCountEl = document.querySelector('[data-pv-cart-itemcount]');
    if (itemCountEl) itemCountEl.textContent = '(' + cart.item_count + ' Item' + (cart.item_count === 1 ? '' : 's') + ')';

    var body = document.querySelector('[data-pv-cart-body]');
    var foots = document.querySelectorAll('[data-pv-cart-foot]');
    var subtotalEl = document.querySelector('[data-pv-cart-subtotal]');
    var totalEl = document.querySelector('[data-pv-cart-total]');
    var checkoutLabel = document.querySelector('[data-pv-checkout-label]');

    updateRewards(cart);

    if (!cart.items.length) {
      if (body) body.innerHTML = '<p class="pv-muted" style="text-align:center;padding:2rem 0;">' + 'Your bag is empty' + '</p>';
      foots.forEach(function (f) { f.hidden = true; });
      sessionStorage.removeItem('pv_cart_reserve_start');
      return;
    }
    foots.forEach(function (f) { f.hidden = false; });

    var discountTotal = collectDiscounts(cart).reduce(function (s, d) { return s + (d.total_allocated_amount || 0); }, 0);
    if (subtotalEl) subtotalEl.textContent = money(cart.items_subtotal_price || cart.total_price + discountTotal);
    /* Checkout adds the flat delivery charge, so the bag total must too or the two disagree. */
    var shipEl = document.querySelector('[data-pv-shipping-label]');
    var shipFee = shipEl ? parseInt(shipEl.getAttribute('data-fee'), 10) || 0 : 0;
    var grandTotal = cart.total_price + shipFee;
    if (totalEl) totalEl.textContent = money(grandTotal);
    if (checkoutLabel) checkoutLabel.textContent = 'Proceed to Secure Checkout • ' + money(grandTotal);
    updatePromo(cart);
    if (pvSyncCoupon) pvSyncCoupon(cart);

    if (!body) return;
    var linesHtml = cart.items.map(function (it) {
      var opts = (it.options_with_values || []).filter(function (o) { return o.value && o.value !== 'Default Title'; })
        .map(function (o) { return o.name + ': ' + o.value; }).join(' · ');
      return '<div class="pv-cart-line" data-line-key="' + it.key + '">' +
        '<div class="pv-cart-line__img">' + (it.image ? '<img src="' + it.image + '" alt="' + it.product_title + '">' : '') + '</div>' +
        '<div class="pv-cart-line__details">' +
          '<a href="' + it.url + '" class="pv-cart-line__name">' + it.product_title + '</a>' +
          (opts ? '<p class="pv-cart-line__variant">' + opts + '</p>' : '') +
          '<div class="pv-cart-line__pricerow">' +
            '<span class="pv-cart-line__price pv-tnum">' + money(it.final_line_price) + '</span>' +
            (it.original_line_price > it.final_line_price ? '<span class="pv-cart-line__was">' + money(it.original_line_price) + '</span>' : '') +
          '</div>' +
          '<div class="pv-cart-line__qtyrow">' +
            '<div class="pv-qtypill">' +
              '<button type="button" data-pv-qty-minus="' + it.key + '" aria-label="Decrease">' + svgMinus() + '</button>' +
              '<span>' + it.quantity + '</span>' +
              '<button type="button" data-pv-qty-plus="' + it.key + '" aria-label="Increase">' + svgPlus() + '</button>' +
            '</div>' +
            '<button type="button" class="pv-cart-line__remove pv-focusable" data-pv-remove="' + it.key + '" aria-label="Remove ' + it.product_title + '">' + svgTrash() + '<span>Remove</span></button>' +
          '</div>' +
        '</div>' +
      '</div>';
    }).join('');

    var reserveHtml = '<div class="pv-reserve"><span class="pv-reserve__left">' + svgHourglass() + '<span>Reserved in your bag for</span></span><span class="pv-reserve__time" data-pv-reserve-time></span></div>';

    var upsellHtml = '<div data-pv-cart-upsell-wrap hidden>' +
      '<div class="pv-upsell__head"><span>Complete The Look</span><span>Bespoke Pairings ' + svgSparkle() + '</span></div>' +
      '<div class="pv-upsell__rail" data-pv-cart-upsell></div>' +
    '</div>';

    body.innerHTML = linesHtml + reserveHtml + upsellHtml;
    initReserveCountdown();
    renderCrossSell(cart.items[cart.items.length - 1].product_id);
  }

  function svgTrash() { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.75" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16M9 7V4h6v3M6 7l1 14h10l1-14"/></svg>'; }
  function svgMinus() { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.75" stroke-linecap="round"><line x1="5" y1="12" x2="19" y2="12"/></svg>'; }
  function svgPlus() { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.75" stroke-linecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>'; }
  function svgHourglass() { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2h12M6 22h12M6 2c0 6 12 6 12 10s-12 4-12 10M18 2c0 6-12 6-12 10s12 4 12 10"/></svg>'; }
  function svgSparkle() { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M12 2v4M12 18v4M4.9 4.9l2.8 2.8M16.3 16.3l2.8 2.8M2 12h4M18 12h4M4.9 19.1l2.8-2.8M16.3 7.7l2.8-2.8"/></svg>'; }

  function fetchCart() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
  }

  function addToCart(fd) {
    return fetch('/cart/add.js', { method: 'POST', body: fd }).then(function (r) { return r.json(); }).then(function (data) {
      if (data && data.status && data.message) window.alert(data.message);
      return data;
    });
  }

  function initCartAjax() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[action*="/cart/add"]');
      if (!form) return;
      e.preventDefault();
      if (!form.checkValidity()) { form.reportValidity(); return; }
      addToCart(new FormData(form)).then(function () {
        fetchCart();
        var drawer = document.querySelector('[data-pv-cart-drawer]');
        if (drawer) openDrawer(drawer);
      }).catch(function () { form.submit(); });
    });

    document.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-pv-remove]');
      if (rm) {
        e.preventDefault();
        fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: rm.getAttribute('data-pv-remove'), quantity: 0 }) })
          .then(function (r) { return r.json(); }).then(handleCartResponse).catch(function () {});
        return;
      }
      var plus = e.target.closest('[data-pv-qty-plus]');
      var minus = e.target.closest('[data-pv-qty-minus]');
      if (plus || minus) {
        e.preventDefault();
        var line = (plus || minus).closest('.pv-cart-line');
        var span = line ? line.querySelector('.pv-qtypill span') : null;
        var current = span ? parseInt(span.textContent, 10) || 1 : 1;
        var next = plus ? current + 1 : Math.max(0, current - 1);
        var key = (plus || minus).getAttribute(plus ? 'data-pv-qty-plus' : 'data-pv-qty-minus');
        fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: next }) })
          .then(function (r) { return r.json(); }).then(handleCartResponse).catch(function () {});
        return;
      }
      var qa = e.target.closest('[data-pv-quickadd]');
      if (qa && qa.tagName === 'BUTTON') {
        e.preventDefault();
        if (qa.classList.contains('is-loading')) return;
        qa.classList.add('is-loading');
        var fd = new FormData();
        fd.append('id', qa.getAttribute('data-variant-id'));
        fd.append('quantity', 1);
        addToCart(fd).then(function () {
          fetchCart();
          var drawer = document.querySelector('[data-pv-cart-drawer]');
          if (drawer) openDrawer(drawer);
        }).finally(function () { qa.classList.remove('is-loading'); });
      }
    });

    fetchCart();
  }

  /* ---------- Coupon code ---------- */
  function initCoupon() {
    var KEY = 'pv_coupon';
    function store(v) { try { if (v) sessionStorage.setItem(KEY, v); else sessionStorage.removeItem(KEY); } catch (e) {} }
    function stored() { try { return sessionStorage.getItem(KEY) || ''; } catch (e) { return ''; } }

    function say(box, text, ok) {
      var msg = box.querySelector('[data-pv-coupon-msg]');
      if (!msg) return;
      msg.hidden = !text;
      msg.textContent = text || '';
      msg.classList.toggle('is-ok', !!ok);
      msg.classList.toggle('is-error', !ok);
    }

    /* Show the "CODE applied · Remove" state whenever the cart carries a discount code,
       whether it was just applied here, applied earlier, or arrived via a /discount/ link. */
    function appliedCode(cart) {
      var found = '';
      (cart.cart_level_discount_applications || []).forEach(function (d) {
        var da = d.discount_application || d;
        if (!found && da.type === 'discount_code') found = da.title || '';
      });
      return found;
    }
    function syncCoupon(cart) {
      var code = appliedCode(cart);
      store(code);
      document.querySelectorAll('[data-pv-coupon]').forEach(function (box) {
        var applied = box.querySelector('[data-pv-coupon-applied]');
        var row = box.querySelector('.pv-coupon__row');
        var label = box.querySelector('.pv-coupon__toggle span');
        if (applied) applied.hidden = !code;
        if (row) row.hidden = !!code;
        if (label) label.textContent = code ? 'Coupon applied' : 'Have a coupon code?';
        var out = box.querySelector('[data-pv-coupon-code]');
        if (out) out.textContent = code;
        if (code) box.open = true;
      });
    }
    pvSyncCoupon = syncCoupon;

    function removeCoupon(box) {
      var btn = box.querySelector('[data-pv-coupon-remove]');
      if (btn) btn.disabled = true;
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: '' }) })
        .then(function (r) { return r.json(); })
        .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
        .then(function (cart) {
          say(box, '', true);
          var input = box.querySelector('[data-pv-coupon-input]');
          if (input) input.value = '';
          if (document.querySelector('.pv-cartpage')) { window.location.reload(); return; }
          renderCart(cart);
        })
        .catch(function () { say(box, 'Couldn\'t remove the code. Please try again.', false); })
        .finally(function () { if (btn) btn.disabled = false; });
    }

    function apply(box) {
      var input = box.querySelector('[data-pv-coupon-input]');
      var btn = box.querySelector('[data-pv-coupon-apply]');
      var code = (input.value || '').trim();
      if (!code) { say(box, 'Enter a coupon code.', false); return; }
      btn.disabled = true;
      say(box, 'Checking…', true);
      /* /discount/CODE saves the code in the session; the cart then reflects it when valid.
         An unknown or ineligible code is silently ignored by Shopify, so compare the cart
         before/after rather than trusting the response. */
      fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
        .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
        .then(function (cart) {
          var ok = collectDiscounts(cart).some(function (d) { return (d.title || '').toLowerCase() === code.toLowerCase(); }) ||
            (cart.cart_level_discount_applications || []).some(function (d) { return ((d.discount_application || d).title || '').toLowerCase() === code.toLowerCase(); });
          if (ok) {
            store(code);
            say(box, code.toUpperCase() + ' applied.', true);
            if (document.querySelector('.pv-cartpage')) { window.location.reload(); return; }
            renderCart(cart);
          } else {
            store('');
            say(box, 'This code isn\'t valid for your bag.', false);
          }
        })
        .catch(function () { say(box, 'Couldn\'t check the code. Please try again.', false); })
        .finally(function () { btn.disabled = false; });
    }

    document.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-pv-coupon-remove]');
      if (rm) { e.preventDefault(); removeCoupon(rm.closest('[data-pv-coupon]')); return; }
      var btn = e.target.closest('[data-pv-coupon-apply]');
      if (!btn) return;
      e.preventDefault();
      apply(btn.closest('[data-pv-coupon]'));
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' || !e.target.matches || !e.target.matches('[data-pv-coupon-input]')) return;
      e.preventDefault();
      apply(e.target.closest('[data-pv-coupon]'));
    });
    /* Forward a verified code to checkout as well (belt and braces with the session cookie). */
    document.addEventListener('submit', function (e) {
      var form = e.target;
      var code = stored();
      if (!code || !form.querySelector || !form.querySelector('[name="checkout"]')) return;
      var hidden = form.querySelector('input[name="discount"]');
      if (!hidden) {
        hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'discount';
        form.appendChild(hidden);
      }
      hidden.value = code;
    }, true);
    fetch('/cart.js').then(function (r) { return r.json(); }).then(syncCoupon).catch(function () {});
    document.querySelectorAll('[data-pv-coupon]').forEach(function (box) {
      var c = stored();
      var input = box.querySelector('[data-pv-coupon-input]');
      if (c && input) { input.value = c; box.open = true; }
    });
  }

  /* ---------- WhatsApp assisted checkout ---------- */
  function initWhatsApp() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-pv-whatsapp]');
      if (!btn) return;
      e.preventDefault();
      var number = (btn.getAttribute('data-number') || '').replace(/[^0-9]/g, '');
      if (!number) return;
      var intro = btn.getAttribute('data-intro') || 'Order:';
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        if (!cart.items.length) { window.alert('Your bag is empty'); return; }
        var lines = cart.items.map(function (it) {
          var opts = (it.options_with_values || []).filter(function (o) { return o.value && o.value !== 'Default Title'; }).map(function (o) { return o.value; }).join(' / ');
          return '• ' + it.product_title + (opts ? ' (' + opts + ')' : '') + ' x' + it.quantity + ' - ' + money(it.final_line_price);
        });
        var msg = intro + '\n\n' + lines.join('\n') + '\n\nTotal: ' + money(cart.total_price);
        window.open('https://wa.me/' + number + '?text=' + encodeURIComponent(msg), '_blank');
      }).catch(function () {});
    });
  }

  /* ---------- Product gallery (dot navigation + view counter) ---------- */
  /* ---------- Horizontal rails must not trap the page's vertical scroll ----------
     A container with only overflow-x can silently swallow a vertical mouse-wheel
     gesture (the browser remaps it to horizontal scroll on that element instead of
     scrolling the page) — that leaves desktop mouse-wheel users stuck the moment
     the cursor is over a rail/gallery. Whenever a wheel gesture is clearly vertical
     (deltaY dominant) and the rail has no room left to move that way itself, hand
     it back to the page instead of letting the browser eat it. */
  function initHorizontalWheelFix() {
    var rails = document.querySelectorAll(
      '[data-pv-gallery-track], .pv-silhouettes__rail, .pv-reviews__rail, .pv-crosssell__rail, .pv-upsell__rail'
    );
    rails.forEach(function (rail) {
      rail.addEventListener('wheel', function (e) {
        if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
          e.preventDefault();
          window.scrollBy(0, e.deltaY);
        }
      }, { passive: false });
    });
  }

  function initGallery() {
    var track = document.querySelector('[data-pv-gallery-track]');
    var dots = document.querySelectorAll('[data-pv-gallery-dot]');
    var indexEl = document.querySelector('[data-pv-gallery-index]');
    if (!track || !dots.length) return;
    function setActive(i) {
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      if (indexEl) indexEl.textContent = i + 1;
    }
    function goTo(i) {
      track.scrollTo({ left: i * track.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
      setActive(i);
    }
    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      setActive(Math.max(0, Math.min(dots.length - 1, i)));
    }, { passive: true });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); });
    });

    // Colour swatches (initProduct) jump the gallery to that colour's first photo.
    galleryGoToMedia = function (mediaId) {
      var slides = track.querySelectorAll('[data-pv-media-id]');
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-pv-media-id') === String(mediaId)) { goTo(i); return; }
      }
    };
  }

  /* ---------- Product page: size selection, demand meter, sticky CTA ---------- */
  function initProduct() {
    var form = document.getElementById('pv-product-form');
    if (!form) return;
    var dataEl = document.querySelector('[data-pv-variants]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent || '[]');
    var optionSelects = form.querySelectorAll('[data-pv-option]');
    var optionRadios = form.querySelectorAll('[data-pv-option-radio]');
    var idSelect = form.querySelector('[data-pv-variant-select]');
    var priceEl = document.querySelector('[data-pv-price-amount]');
    var stockNote = document.querySelector('[data-pv-stock-note]');
    var lowStockThreshold = parseInt((stockNote && stockNote.getAttribute('data-threshold')) || '5', 10);
    var stickyPrice = document.querySelector('[data-pv-sticky-price]');
    var stickySize = document.querySelector('[data-pv-sticky-size]');
    var stickyCta = document.querySelector('[data-pv-add-to-bag]');
    var ctaLabel = document.querySelector('[data-pv-cta-label]');
    var addLabel = ctaLabel ? ctaLabel.textContent.trim() : 'Add to Bag';
    var colourBlock = form.querySelector('[data-pv-option-block="Colour"], [data-pv-option-block="Color"]');
    var sizeBlock = form.querySelector('[data-pv-option-block="Size"]');

    // No size is pre-selected: Shopify defaults to the first variant (XS), and shoppers who
    // miss that order the wrong size. Unless they arrived with a specific ?variant=, clear it
    // and make them choose before they can add to bag.
    if (sizeBlock && !/[?&]variant=/.test(location.search)) {
      sizeBlock.querySelectorAll('[data-pv-option-radio]:checked').forEach(function (r) { r.checked = false; });
    }
    function sizePending() {
      return !!sizeBlock && !sizeBlock.querySelector('[data-pv-option-radio]:checked');
    }
    function nudgeSize() {
      if (!sizeBlock) return;
      sizeBlock.classList.remove('is-nudge');
      void sizeBlock.offsetWidth;
      sizeBlock.classList.add('is-nudge');
      sizeBlock.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
    }

    // Each option (Colour, Size, or a generic one) contributes one value, keyed by its
    // 0-based position (matches variant.options[]) — a radio group or a <select>.
    function findVariant() {
      var chosenByPosition = {};
      form.querySelectorAll('[data-pv-option-radio]:checked').forEach(function (r) {
        chosenByPosition[r.getAttribute('data-pv-option-position')] = r.value;
      });
      optionSelects.forEach(function (s) {
        chosenByPosition[s.getAttribute('data-pv-option-position')] = s.value;
      });
      var positions = Object.keys(chosenByPosition);
      if (!positions.length) return variants[0] || null;
      positions.sort(function (a, b) { return Number(a) - Number(b); });
      var chosen = positions.map(function (p) { return chosenByPosition[p]; });
      return variants.find(function (v) { return v.options.every(function (o, i) { return o === chosen[i]; }); }) || null;
    }

    function updateStockNote(match, sizeRadio, colourRadio) {
      if (!stockNote) return;
      var demandWrap = document.querySelector('[data-pv-demand]');
      var hasStaticNote = demandWrap && demandWrap.querySelector('.pv-demand__row');
      var qty = match && match.inventory_management ? match.inventory_quantity : null;
      var checkedRadio = sizeRadio || colourRadio;
      if (match && match.available && qty !== null && qty !== undefined && qty > 0 && qty <= lowStockThreshold) {
        var textEl = stockNote.querySelector('[data-pv-stock-text]');
        var sizedTpl = sizeRadio ? stockNote.getAttribute('data-tpl-size')
          : colourRadio ? stockNote.getAttribute('data-tpl-colour') : null;
        var tpl = sizedTpl || stockNote.getAttribute('data-tpl-plain');
        if (textEl) textEl.textContent = tpl.replace('%COUNT%', qty).replace('%SIZE%', checkedRadio ? checkedRadio.value : '');
        var batchLabel = stockNote.querySelector('[data-pv-batch-label]');
        if (batchLabel) batchLabel.textContent = stockNote.getAttribute('data-batch-label') || '';
        var fill = stockNote.querySelector('[data-pv-batch-fill]');
        if (fill) {
          var batchSize = parseInt(fill.getAttribute('data-batch-size'), 10);
          if (batchSize > 0) {
            var claimedPct = Math.max(4, Math.round((1 - (qty / batchSize)) * 100));
            fill.style.width = Math.min(100, claimedPct) + '%';
          }
        }
        stockNote.hidden = false;
        if (demandWrap) demandWrap.hidden = false;
      } else {
        stockNote.hidden = true;
        if (demandWrap && !hasStaticNote) demandWrap.hidden = true;
      }
    }

    function update() {
      if (sizePending()) {
        var pendingColour = colourBlock ? colourBlock.querySelector('[data-pv-option-radio]:checked') : null;
        if (stickySize) stickySize.textContent = (pendingColour ? pendingColour.value + ' • ' : '') + 'Select a size';
        form.querySelectorAll('[data-pv-option-block]').forEach(function (block) {
          var head = block.previousElementSibling;
          var label = head && head.querySelector('[data-pv-selected-label]');
          var checked = block.querySelector('[data-pv-option-radio]:checked');
          if (label) label.textContent = checked ? '(' + checked.value + ' Selected)' : '';
        });
        if (ctaLabel) ctaLabel.textContent = 'Select Size';
        if (stickyCta) stickyCta.disabled = false;
        if (pendingColour && galleryGoToMedia) {
          var cv = variants.find(function (v) { return v.options.indexOf(pendingColour.value) > -1 && v.featured_image; });
          if (cv) galleryGoToMedia(cv.featured_image.id);
        }
        return;
      }
      var match = findVariant();
      if (!match) return;
      if (idSelect) idSelect.value = match.id;
      var priceStr = money(match.price);
      if (priceEl) priceEl.textContent = priceStr;
      if (stickyPrice) stickyPrice.textContent = priceStr;

      var sizeRadio = sizeBlock ? sizeBlock.querySelector('[data-pv-option-radio]:checked') : null;
      var colourRadio = colourBlock ? colourBlock.querySelector('[data-pv-option-radio]:checked') : null;

      if (stickySize && sizeRadio) {
        stickySize.textContent = 'Size ' + sizeRadio.value + ' • Delivered in 7 days';
      } else if (stickySize && colourRadio) {
        stickySize.textContent = colourRadio.value + ' • Delivered in 7 days';
      }

      // Each option block shows its own "(Value Selected)" label.
      form.querySelectorAll('[data-pv-option-block]').forEach(function (block) {
        var checked = block.querySelector('[data-pv-option-radio]:checked');
        if (!checked) return;
        var head = block.previousElementSibling;
        var label = head && head.querySelector('[data-pv-selected-label]');
        if (label) label.textContent = '(' + checked.value + ' Selected)';
      });

      if (stickyCta) stickyCta.disabled = !match.available;
      if (ctaLabel) ctaLabel.textContent = match.available ? addLabel : 'Sold Out';

      if (colourRadio && match.featured_image && galleryGoToMedia) {
        galleryGoToMedia(match.featured_image.id);
      }

      updateStockNote(match, sizeRadio, colourRadio);
    }
    form.addEventListener('submit', function (e) {
      if (sizePending()) { e.preventDefault(); e.stopImmediatePropagation(); nudgeSize(); }
    }, true);
    optionSelects.forEach(function (s) { s.addEventListener('change', update); });
    optionRadios.forEach(function (r) { r.addEventListener('change', update); });
    update();

    if (stickyCta) {
      stickyCta.addEventListener('click', function () {
        if (stickyCta.disabled) return;
        if (sizePending()) { nudgeSize(); return; }
        var submitBtn = form.querySelector('[data-pv-form-submit]');
        if (submitBtn) {
          if (typeof form.requestSubmit === 'function') form.requestSubmit(submitBtn);
          else submitBtn.click();
        }
      });
    }
  }

  /* ---------- Delivery pincode checker (format check + generic policy copy) ---------- */
  function initPincode() {
    var input = document.querySelector('[data-pv-pincode-input]');
    var checkBtn = document.querySelector('[data-pv-pincode-check]');
    var clearBtn = document.querySelector('[data-pv-pincode-clear]');
    var result = document.querySelector('[data-pv-pincode-result]');
    if (!input || !checkBtn || !result) return;
    var promiseText = result.querySelector('.pv-delivery__promise');
    var subText = result.querySelector('.pv-muted');
    var origPromise = promiseText ? promiseText.textContent : '';
    var origSub = subText ? subText.textContent : '';

    checkBtn.addEventListener('click', function () {
      var val = input.value.trim();
      if (/^\d{6}$/.test(val)) {
        result.classList.remove('is-error');
        if (promiseText) promiseText.textContent = 'Delivery available to ' + val;
        if (subText) subText.textContent = origSub;
      } else {
        result.classList.add('is-error');
        if (promiseText) promiseText.textContent = 'Please enter a valid 6-digit pincode';
        if (subText) subText.textContent = '';
      }
    });
    if (clearBtn) clearBtn.addEventListener('click', function () {
      input.value = '';
      input.focus();
      result.classList.remove('is-error');
      if (promiseText) promiseText.textContent = origPromise;
      if (subText) subText.textContent = origSub;
    });
  }

  /* ---------- Atelier dossier accordion ---------- */
  function initAccordion() {
    document.addEventListener('click', function (e) {
      var head = e.target.closest('[data-pv-accordion-toggle]');
      if (!head) return;
      var wrap = head.closest('[data-pv-accordion]');
      var body = wrap.querySelector('[data-pv-accordion-body]');
      var isHidden = body.hasAttribute('hidden');
      if (isHidden) { body.removeAttribute('hidden'); wrap.classList.add('is-open'); }
      else { body.setAttribute('hidden', ''); wrap.classList.remove('is-open'); }
    });
  }

  /* ---------- Live purchase ticker (rotates through merchant-entered real entries) ---------- */
  function initLiveTicker() {
    var ticker = document.querySelector('[data-pv-ticker]');
    var dataEl = document.querySelector('[data-pv-ticker-data]');
    if (!ticker || !dataEl) return;
    var entries;
    try { entries = JSON.parse(dataEl.textContent || '[]'); } catch (e) { entries = []; }
    if (!entries.length) return;
    var textEl = ticker.querySelector('[data-pv-ticker-text]');
    var timeEl = ticker.querySelector('[data-pv-ticker-time]');
    var i = 0;
    function render() {
      var d = entries[i];
      if (textEl) textEl.innerHTML = '<strong>' + d.name + '</strong> from ' + d.city + ' purchased <em>' + d.item + '</em>';
      if (timeEl) timeEl.textContent = d.time;
    }
    render();
    if (reduceMotion || entries.length < 2) return;
    setInterval(function () {
      i = (i + 1) % entries.length;
      ticker.style.opacity = '0';
      ticker.style.transform = 'translateY(4px)';
      setTimeout(function () { render(); ticker.style.opacity = '1'; ticker.style.transform = 'translateY(0)'; }, 250);
    }, 6000);
  }

  /* ---------- Wishlist page (/pages/wishlist, if the merchant creates it) ---------- */
  function initWishlistPage() {
    var grid = document.querySelector('[data-pv-wishlist-grid]');
    if (!grid) return;
    renderWishlistInto(grid, document.querySelector('[data-pv-wishlist-empty]'), 'grid');
  }
  function svgHeart() { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.75" stroke-linecap="round" stroke-linejoin="round"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8z"/></svg>'; }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initHeaderActions();
    initDrawers();
    initWishlist();
    initCartAjax();
    initCoupon();
    initWhatsApp();
    initGallery();
    initHorizontalWheelFix();
    initProduct();
    initPincode();
    initAccordion();
    initLiveTicker();
    initWishlistPage();
  });
})();
